(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('ServiceTimeSessionServant', ServiceTimeSessionServant);

    ServiceTimeSessionServant.$inject = ['$resource'];

    function ServiceTimeSessionServant($resource) {
        var resourceUrl = 'api/service-time-session-servants/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
